<template>
    <div class="MyPurchaseStyle">
        <top-component ref="topHeader"></top-component>
        <div class="PurchaseTwoTop">
            <div class="PurchaseTwoTop-container" @click="next">我的采购</div>
        </div>
        <div class="PurchaseLiucheng">
            <el-steps :active="active" finish-status="success">
                <el-step title="检查订单"></el-step>
                <el-step title="确认采购单"></el-step>
                <el-step title="完成采购"></el-step>
            </el-steps>
        </div>
        <!-- 设置复本数 -->
        <div class="PurchaseContainer setNumber">
            <el-button type="primary" size="mini" @click="addSetNumberRule">新增复本数规则</el-button>
            <div class="set_wrap" v-if="numRule.length > 0">
                <div class="setRule" v-for="(item, index) in numRule" :key="index">
                    单价在<el-input size="mini" v-model="item.moreEq" disabled />~<el-input size="mini" v-model="item.less" disabled />元（{{item.moreEq}} ≤ X < {{item.less}}）之间，复本数为<el-input size="mini" v-model="item.copy" disabled />
                    <el-button type="primary" plain size="mini" icon="el-icon-edit" @click="saveNumberRule(index)"></el-button>
                    <el-button v-if="numRule.length > 1" type="danger" plain size="mini" icon="el-icon-delete" @click="delNumberRule(item.id)"></el-button>
                </div>
                <el-button type="success" size="mini" @click="applyRule">应用</el-button>
            </div>
        </div>
        <div class="PurchaseSearch">
            <label>用户：</label>
            <Select clearable v-model="serchUserId" placeholder="请选择" class="sel_collection" v-if="adminState == 1" @change="changeSelect" >
                <Option v-for="item in objUserArr" :key="item.user_gid" :label="item.real_name" :value="item.user_gid" ></Option>
            </Select>
           <!--  <label>来源：</label>
            <Select v-model="serchSource" placeholder="请选择" class="sel_collection" @change="changeSelect">
                <Option v-for="item in sourceArr" :key="item.key" :label="item.value" :value="item.key"></Option>
            </Select>
            <label>商品类型：</label>
            <Select v-model="serchGoodsType" placeholder="请选择" class="sel_collection" @change="changeSelect">
                <Option v-for="item in goodsTypeArr" :key="item.key" :label="item.value" :value="item.key"></Option>
            </Select>
            <label v-if="adminState == 1">根据身份筛选：</label>
            <Select v-model="IDGoodsType" placeholder="请选择" v-if="adminState == 1" class="sel_collection" @change="changeSelect">
                <Option v-for="item in IDTypeArr" :key="item.key" :label="item.value" :value="item.key"></Option>
            </Select> -->
            
        </div> 
        <!-- <div class="PurchaseSearch" style="display: flex;" >
            <div>预警额度为: <span style="color:red; margin-right: 15px; font-size: 20px;">{{setParams}}</span></div> 
            <div>可用额度为: <span style="color:royalblue; font-size: 20px;">{{balance}}</span></div> 
        </div> -->
        <div class="PurchaseContainer">
            <el-tabs @tab-click="tabHandleClick">
                <el-tab-pane label="全量购物车"></el-tab-pane>
                <el-tab-pane label="与馆藏重复"></el-tab-pane>
                <el-tab-pane label="无馆藏重复"></el-tab-pane>
            </el-tabs>
            <div class="loading-wrap">
                <el-table
                    class="MouseCursor"
                    ref="multipleTable"
                    v-bind:data="tableData"
                    @select="selectChange"
                    @select-all="selectAllChange"
                    @selection-change="selectionChangeHandler"
                >
                    <el-table-column type="selection" />
                    <el-table-column label="商品" width="200">
                        <template slot-scope="scope">
                            <span @click="goDetail(scope.row)">{{ scope.row.goodsName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单价" width="150" align="center">
                        <template slot-scope="scope">
                            <span>￥{{ scope.row.price }}</span>&emsp;
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" width="150" align="center">
                        <template slot-scope="scope">
                            <el-input-number
                                size="mini"
                                v-model="scope.row.amount"
                                v-on:change="numberChangeHandler(scope.row)"
                                v-bind:min="1"
                            />
                            <span
                                class="guancangBook"
                                v-if="Number(GuanNumBook[scope.row.gid]) !== 0"
                            >已有馆藏数量{{GuanNumBook[scope.row.gid]}}本</span>
                            <span class="guancangBook" v-else></span>
                        </template>
                    </el-table-column>
                    <el-table-column width="230" align="center" label="小计">
                        <template slot-scope="scope">
                            <span>￥{{ scope.row.subtotal }}</span>&emsp;
                        </template>
                    </el-table-column>

                    <el-table-column width="100" align="center" label="商品类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.goodsType == 2">电子书</span>
                            <span v-else-if="scope.row.goodsType == 1">纸质书</span>
                            <span v-else>其他</span>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column width="150" align="center" label="来源">
                        <template slot-scope="scope">
                            <span >{{scope.row.source == 0? '手动加入':'荐购加入'}}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column width="150" align="center" prop="username" label="加购人"></el-table-column>
                    <el-table-column label="操作" align="center" >
                        <template slot-scope="scope">
                            <el-button
                                @click="deleteRowHandler(scope.row, scope.$index)"
                                size="small" v-if="shoppingCartPermissions != 0"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="totalTo clearfix">
                    <div class="fl">
                        <el-checkbox
                            v-model="checked"
                            :indeterminate="isdeterminate"
                            @change="toggleSelection"
                        >当页全选</el-checkbox>
                    </div>
                    <el-pagination
                        class="fr"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="pageNum"
                        :page-size="pageSize"
                        :total="totalList"
                        :page-sizes="[10, 20, 50, 200]"
                        layout="prev, pager, next, jumper, total,sizes"
                    ></el-pagination>
                </div>
                <div class="totalTo clearfix" style="margin-top: 2px;"   v-if="!isDataNull">
                    <!--  v-if="showGoods"  v-if="!showGoods"-->
                    <!-- <el-button size="mini" type="primary" @click="allGuanZhong">与馆查重</el-button> -->
                    <!-- <el-button size="mini" type="primary" @click="GoodsAll">显示所有购物车数量</el-button> -->
                    <div class="fl" v-if="shoppingCartPermissions != 0">
                        <el-button size="mini" type="primary" @click="DeleteButton">批量删除</el-button>
                    </div>
                    <div class="totalToRight fr">
                        <!--已优惠 ￥{{ discount }}，-->
                        <div>已选{{ quantity }}种（{{ quantityNum }}册）商品，合计￥{{ total.toFixed(2) }}</div>&emsp;
                        <el-button size="mini" type="warning" @click="submitOrderHandler" v-loading="loading">提交所选采购单</el-button>
                    </div>
                    <div class="fr" style="padding-right:20px;">
                        <el-input-number size="mini" v-model="FixedNum" @change="handleChange" :min="1" :max="10" label="描述文字"></el-input-number>
                        <el-button size="mini" type="success" @click="handleButton">修改选中数量</el-button>
                        <el-button size="mini" type="success" @click="handleButtonAll">修改全部数量</el-button>
                    </div>
                </div>
                <div class="totalTo clearfix" style="margin-top: 2px;"  v-if="!isDataNull">
                    <div class="fl" v-if="shoppingCartPermissions != 0">
                        <el-button size="mini" type="primary" @click="clearAllSubmit">全部清空</el-button>
                    </div>
                    <div class="totalToRight fr">
                        <!--已优惠 ￥{{ discount }}，-->
                        <div>全部共{{ totalPZ }}种（{{ totalCS }}册）商品，总合计￥{{ totalPrice }}</div>&emsp;
                        <el-button size="mini" type="warning" @click="submitAllOrderHandler" v-loading="loading">提交全部采购单</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="PurchaseContainer"  v-if="false">
            <div class style="text-align:center;padding:100px 0px;color:#666;">购物车暂无数据！</div>
        </div>
        <bottom-component></bottom-component>
    </div>
</template>

<script>
import { Tabs, TabPane, Loading, Select, Option } from "element-ui";
import TopComponent from "../Components/TopComponentcopy.vue";
import BottomComponent from "../Components/BottomComponent.vue";
import { actionlist,actionlist2, repeatChecklist, ordersave, allOrdersave, actiondelete, actionsave, actionbatchSave, updateAmountAll, actionbatchDelete, actionClearAll, allAmount } from "@/api/pages.js";
import { Bookactionsearch } from "@/api/authority";
import Cookies from "js-cookie";
import axios from "axios";
import DiyAxios from '@/api/diyaxios'
import { insertPoint } from '@/api/insertPoints'   //
import popup from "../../common/plugin/dialog/index.js";
import setRule from '../../components/setCopyRule.vue'
import { getSystemList, systemEdit } from '@/api/manage.js'

export default {
    name: "MyPurchase",
    data() {
        return {
            showLoading: null,
            active: 0,
            tableData: [],
            selectTableData: [],
            booksJson: [],
            Objectkey: [],
            ObjectValue: {},
            checked: false,
            isdeterminate: false,
            // checkedBook: false,
            // CaRGoodsLenght: 0,
            // 批量修改数量
            FixedNum: 1,
            FixedNumArr: [],
            // 批量删除
            DeleteNumArr: [],
            // 有馆藏数据的书本Id的数组 + 值
            GuanNumBook: {},
            showGoods: true,
            loading: false,
            pageSize: 20,
            pageNum: 1,
            totalList: 0,
            curArr: [],
            tabIndex: "0",
            totalPZ: 0,
            totalCS: 0,
            totalPrice: 0,
            isDataNull: false,
            adminState:Cookies.get("adminState"),
            serchUserId:Cookies.get("UserID"),
            shoppingCartPermissions:Cookies.get("shoppingCartPermissions"),
            objUserArr:[],
            serchSource:'0',
            sourceArr:[{key:'',value:'全部'},{key:0,value:'手动加入'},{key:1,value:'荐购加入'}],
            serchGoodsType:'',
            goodsTypeArr:[{key:'',value:'全部'},{key:1,value:'纸质书'},{key:2,value:'电子书'},{key:3,value:'其他'}],
            IDTypeArr:[{key:'',value:'全部'},{key:0,value:'普通用户'},{key:1,value:'管理员'},{key:2,value:'读者'},{key:3,value:'教师'},{key:4,value:'学生'}],
            IDGoodsType:'',
            numRule: [],
            setParams:'',
            orgGid: JSON.parse(localStorage.getItem('user')).orgGid,//JSON.parse(localStorage.getItem('user')).orgGid,
        };
    },
    mounted() {
        //管理员显示用户下拉
        this.getUserlist();
        this.getShopCarData();
        // this.searchNumberRule();  //获取复本数规则
        // this.getSystemRule();
    },
    computed: {
        // balance(){
        //     return this.setParams - this.totalPrice
        // },
        quantity() {
            // 商品类型数量
            return this.selectTableData.length;
        },
        quantityNum() {
            // 商品总数
            return this.selectTableData.reduce((count, item) => {
                return count + item.amount;
            }, 0);
        },
        discount() {
            // 总优惠价
            return this.selectTableData.reduce((count, item) => {
                return count + (item.price - item.discountPrice) * item.amount;
            }, 0);
        },
        total() {
            // 商品总价
            return this.selectTableData.reduce((count, item) => {
                return count + Number(item.subtotal);
            }, 0);
        }
    },
    methods: {
        // getSystemRule(){
        //         let vm = this;
        //         getSystemList({
        //             orgid: vm.orgGid,
        //         }).then(res => {
        //             if(res.status){
        //                 vm.setParams = res.data[4].field;  
        //             }
        //         }).catch(err => {

        //         });
        //     },
        //设置复本数弹窗
        showSetPop(type, data) {
            let vm = this;
            vm.set_pop = popup('<set-rule @close="close" @submit="submit" :type="type" :ruledata="data" />', {
                option: {
                    title: type == 0 ? '新增复本数规则' : '修改复本数规则',
                    width: '560px'
                },
                popup: {
                    data() {
                        return {
                            type: type,
                            data: data
                        };
                    },
                    components: {
                        setRule
                    },
                    methods: {
                        submit(res) {
                            vm.editNumberRule(type, res);
                            vm.set_pop.hide();
                        },
                        close(){
                            vm.set_pop.hide();
                        }
                    }
                }
            }
            );
            vm.set_pop.show();
        },
        //点击新增设置复本数规则
        addSetNumberRule(){
            let vm = this;
            vm.showSetPop('0', '');
        },
        //点击删除
        delNumberRule(id){
            let vm = this;
            vm.$confirm("确定要删除该复本数规则吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                DiyAxios.post('/copy/action/remove?ids='+id, {
                    params:{
                    }
                }).then(res => {
                    if(res.status){                        
                        vm.$message({ message: '删除成功！', type: 'success'});
                        vm.searchNumberRule();
                    }
                }).catch(res => {
                })
            }).catch(() => {});
        },
        //编辑
        saveNumberRule(index){
            let vm = this,
                data = vm.numRule[index],
                ruleData = {
                    id: data.id,
                    copy: data.copy,
                    moreEq: data.moreEq,
                    less: data.less
                };
            vm.showSetPop('1', ruleData);
        },
        //应用规则
        applyRule(){         
            let vm = this;
            vm.$confirm("确定应用该规则到购物车吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                DiyAxios.post('/copy/action/batchEdit', {
                    params:{
                        userid: vm.serchUserId
                    }
                }, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then(res => {
                    if(res.status){                        
                        vm.$message({ message: '应用成功！', type: 'success'});
                        vm.getShopCarData(); //刷新购物车
                    }
                }).catch(res => {
                })
            }).catch(() => {});
        },
        //查询副本规则
        searchNumberRule(){            
            let vm = this;
            DiyAxios.post('/copy/action/list', {
                params:{
                    userId: vm.serchUserId
                }
            },{
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                if(res.status){
                    vm.numRule = res.data;
                }
            }).catch(res => {
            })
        },
        //新增、修改副本规则     
        editNumberRule(type, data){            
            let vm = this,
                url = type == 0 ? '/copy/action/add' : '/copy/action/edit';
            DiyAxios.post(url, {
                params: data
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                if(res.status){
                    vm.$message({ message: type == '0' ? '新增成功！' : '修改成功！', type: 'success'});
                    vm.searchNumberRule();
                }
            }).catch(res => {
                vm.$message({ message: res.errorMsg || '操作失败！', type: 'success'});
            })
        },
        // 步骤条的点击事件
        next() {
            if (this.active++ > 2) this.active = 0;
        },
        tabHandleClick(tab, event) {
            let vm = this;
            vm.tabIndex = tab.index;
            vm.pageSize = 20;
            vm.pageNum = 1;
            vm.checked = false;
            vm.isdeterminate = false;
            vm.selectTableData = [];
            vm.showLoading.close();
            vm.getShopCarData();
        },
        goDetail(item) {
            // Cookies.set("LookPubgoodsIdDetaildataID", item.goodsId);
            const { href } = this.$router.resolve({
                name: "BookDetail",
                params: { goodsId: item.goodsId }
            });
            window.open(href, "_blank");
        },
        getAllAmount() {
            let vm = this,
                ckindex = "-1",
                obj = {};
            if (vm.tabIndex == "1") {
                ckindex = "1";
            } else if (vm.tabIndex == "2") {
                ckindex = "0";
            }
            obj = {
                userType:vm.IDGoodsType,
                userId: vm.serchUserId,
                cknums: ckindex,
                source:vm.serchSource,
                goodsType:vm.serchGoodsType,

            };
            allAmount(obj).then(response => {
                if (response && response.status) {
                    vm.$store.state.DataStorage.GoodLengthData = response.data.pz;
                    vm.totalList = response.data.pz;
                    vm.totalPZ = response.data.pz || 0;
                    vm.totalCS = response.data.fb || 0;
                    vm.totalPrice = response.data.zj || 0;
                }
            });
        },
        // 展示购物车数据
        async getShopCarData() {
            let vm = this,
                data = {
                    userType:vm.IDGoodsType,
                    userId: vm.serchUserId,
                    source: vm.serchSource,
                    goodsType:vm.serchGoodsType,
                    pageSize: vm.pageSize,
                    pageNum: vm.pageNum
                };
            vm.tableData = [];
            vm.showLoading = Loading.service({
                target: document.querySelector(".loading-wrap"),
                spinner: "el-icon-loading",
                text: "加载中...",
                background: "rgba(255, 255, 255, 0.5)"
            });
            if(vm.tabIndex != 1 && vm.tabIndex != 2){
                let res = await actionlist2(data)
                if (res.data.total > 0) {
                        vm.$store.state.DataStorage.GoodLengthData = res.data.total;
                        vm.isDataNull = false;
                        if (res.data.list.length == 0 && vm.pageNum != 1) {
                            vm.pageNum = 1;
                            vm.getShopCarData();
                        } else {
                            vm.tableData = res.data.list.map(item => {
                                var data = (item.price * item.amount).toFixed(2);
                                item.subtotal = data;
                                return item;
                            });
                            for (var i = 0; i < vm.tableData.length; i++) {
                                // 展示已有馆藏的数据
                                vm.$set(vm.GuanNumBook, vm.tableData[i].gid, 0);
                            }
                            vm.totalList = res.data.total;
                            //回显
                            vm.$nextTick(() => {
                                let sellist = [];
                                vm.tableData.forEach((ele, i) => {
                                    vm.selectTableData.forEach((element, j) => {
                                        if (ele.gid == element.gid) {
                                            sellist.push(ele);
                                            vm.$set(vm.selectTableData, j, ele);
                                        }
                                    });
                                });
                                vm.toggleSelectionCheck(sellist);
                                vm.showLoading.close();
                                vm.getAllAmount();
                            });
                        }
                    } else {
                        // vm.tabIndex == '0' ? vm.isDataNull = true : vm.isDataNull = false;  
                        vm.isDataNull = true;
                         vm.getAllAmount();
                        vm.showLoading.close();
                    }
            }else{
                if(vm.tabIndex == 1){
                data.cknums = 1;
               }else if(vm.tabIndex == 2){
                data.cknums = 0;
               }
               let res = await actionlist(data)
               if (res.data.total > 0) {
                        vm.isDataNull = false;
                        if (res.data.list.length == 0 && vm.pageNum != 1) {
                            vm.pageNum = 1;
                            vm.getShopCarData();
                        } else {
                            vm.tableData = res.data.list.map(item => {
                                var data = (item.price * item.amount).toFixed(2);
                                item.subtotal = data;
                                return item;
                            });
                            for (var i = 0; i < vm.tableData.length; i++) {
                                // 展示已有馆藏的数据
                                vm.$set(vm.GuanNumBook, vm.tableData[i].gid, 0);
                            }
                            vm.totalList = res.data.total;
                            //回显
                            vm.$nextTick(() => {
                                let sellist = [];
                                vm.tableData.forEach((ele, i) => {
                                    vm.selectTableData.forEach((element, j) => {
                                        if (ele.gid == element.gid) {
                                            sellist.push(ele);
                                            vm.$set(vm.selectTableData, j, ele);
                                        }
                                    });
                                });
                                vm.toggleSelectionCheck(sellist);
                                vm.showLoading.close();
                                vm.getAllAmount();
                            });
                        }
                    } else {
                        // vm.tabIndex == '0' ? vm.isDataNull = true : vm.isDataNull = false;  
                        vm.isDataNull = true;
                         vm.getAllAmount();
                        vm.showLoading.close();
                    }
            }
        },

        changeSelect(){
            let vm = this;
            vm.pageSize = 20;
            vm.pageNum = 1;
            vm.checked = false;
            vm.isdeterminate = false;
            vm.selectTableData = [];
            vm.showLoading.close();
            vm.getShopCarData();

        },
        //用户下拉
        getUserlist(){
            let vm = this;
            DiyAxios.post('/user/action/list', {params:{userId:vm.serchUserId}}, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then(res => {
                try{
                   vm.objUserArr = res.data || [];
                }catch(e){
                }
            }).catch(res => {
            })
        },

        // 下面的全选
        toggleSelection(value) {
            let vm = this;
            if (value) {
                //全选
                vm.curArr.forEach(ele => {
                    vm.$refs.multipleTable.toggleRowSelection(ele);
                });
                vm.tableData.forEach(row => {
                    vm.$refs.multipleTable.toggleRowSelection(row);
                });
                let dataGid = vm.getGids(vm.tableData);
                let cGid = vm.getGids(vm.selectTableData);
                for (var a = 0; a < dataGid.length; a++) {
                    if (cGid.indexOf(dataGid[a]) < 0) {
                        vm.selectTableData.push(vm.tableData[a]);
                    }
                }
            } else {
                //全不选
                let d = vm.tableData;
                for (var a = 0; a < d.length; a++) {
                    let i = vm.getGids(vm.selectTableData).indexOf(d[a].gid);
                    if (i > -1) vm.selectTableData.splice(i, 1);
                }
                vm.$refs.multipleTable.clearSelection();
            }
        },
        toggleSelectionCheck(rows) {
            //checked选中行
            if (rows.length > 0) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        selectChange(selectRow, row) {
            let vm = this,
                index = vm.getGids(vm.selectTableData).indexOf(row.gid);
            if (index > -1) {
                vm.selectTableData.splice(index, 1);
            } else {
                vm.selectTableData.push(row);
            }
            // console.info(vm.selectTableData);
        },
        selectAllChange(selection) {
            let vm = this;
            if (selection.length > 0) {
                //全选
                let dataGid = vm.getGids(vm.tableData);
                let cGid = vm.getGids(vm.selectTableData);
                for (var a = 0; a < dataGid.length; a++) {
                    if (cGid.indexOf(dataGid[a]) < 0) {
                        vm.selectTableData.push(vm.tableData[a]);
                    }
                }
            } else {
                //全不选
                let d = vm.tableData;
                for (var a = 0; a < d.length; a++) {
                    let i = vm.getGids(vm.selectTableData).indexOf(d[a].gid);
                    if (i > -1) vm.selectTableData.splice(i, 1);
                }
            }
        },
        // 选择项发生变化时触发该事件
        selectionChangeHandler(arr) {
            let vm = this;
            vm.curArr = arr;
            if (arr.length == vm.pageSize) {
                vm.checked = true;
                vm.isdeterminate = false;
            } else if (arr.length == 0) {
                vm.checked = false;
                vm.isdeterminate = false;
            } else if (arr.length < vm.pageSize) {
                vm.checked = false;
                vm.isdeterminate = true;
            }
        },
        getGids(arr = []) {
            if (arr.length < 1) return [];
            let gids = [];
            for (let i = 0; i < arr.length; i++) {
                gids.push(arr[i].gid);
            }
            return gids;
        },
        //批量修改
        handleChange(value) {
            // console.log(value)
        },
        handleButtonAll() {
            let vm = this,
                ckindex = "-1",
                obj = {};
            if (vm.tabIndex == "1") {
                ckindex = "1";
            } else if (vm.tabIndex == "2") {
                ckindex = "0";
            }
            obj = {
                userType:vm.IDGoodsType,
                userId: vm.serchUserId,
                source: vm.serchSource,
                goodsType: vm.serchGoodsType,
                cknums: ckindex,
                amount: vm.FixedNum
            };
            updateAmountAll(obj).then(response => {
                if(response.data){
                    vm.$message({
                        message: "修改数量成功！",
                        type: "success"
                    });
                    // this.FixedNum = 1;
                    vm.getShopCarData();
                }else{
                    vm.$message({
                        message: "修改数量失败！",
                        type: "error"
                    });
                }
            });
        },
        //批量修改
        handleButton() {
            this.FixedNumArr = [];
            if (this.selectTableData.length > 0) {
                for (var i = 0; i < this.selectTableData.length; i++) {
                    this.FixedNumArr.push({
                        amount: this.FixedNum,
                        cartId: this.selectTableData[i].cartId
                    });
                }
                actionbatchSave(this.FixedNumArr).then(response => {
                    this.$message({
                        message: "批量修改数量成功！",
                        type: "success"
                    });
                    this.getShopCarData();
                });
            } else {
                this.$message({
                    message: "您还没有选择书本！",
                    type: "warning"
                });
            }
        },
        //清空购物车
        clearAllSubmit() {
            let vm = this;
            vm.$confirm("确定要清空购物车吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                vm.showLoading = Loading.service({
                target: document.querySelector(".loading-wrap"),
                spinner: "el-icon-loading",
                text: "加载中...",
                background: "rgba(255, 255, 255, 0.5)"
            });
                let obj = {
                    userType:vm.IDGoodsType,
                    userId: vm.serchUserId,
                    source:vm.serchSource,
                    goodsType:vm.serchGoodsType,
                    cknums: "-1"
                };
                actionClearAll(obj).then(response => {
                    vm.$message({
                        message: "已清空购物车！",
                        type: "success"
                    });
                    vm.showLoading.close();
                    // vm.isDataNull = true;
                    this.getShopCarData();
                }).catch(() => {
                    vm.$message({
                        message: "清空失败！",
                        type: "success"
                    });
                vm.showLoading.close();
            });;
            }).catch(() => {
                vm.showLoading.close();
            });
        },
        //批量删除
        DeleteButton() {
            if (this.selectTableData.length < 1) {
                this.$message({
                    message: "您还没有选择书本！",
                    type: "warning"
                });
            } else {
                this.$confirm("确定要删除吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        for (var i = 0; i < this.selectTableData.length; i++) {
                            this.DeleteNumArr.push(
                                this.selectTableData[i].cartId
                            );
                        }
                        actionbatchDelete(this.DeleteNumArr).then(response => {
                            this.$message({
                                message: "批量删除成功！",
                                type: "success"
                            });
                            this.selectTableData = [];
                            this.getShopCarData();
                        });
                    })
                    .catch(() => {});
            }
        },
        // 当某商品的数量发生变化
        numberChangeHandler(row) {
            // 数量变化的时候，小计随着变化
            var data = (row.price * row.amount).toFixed(2);
            row.subtotal = data;
            // row.subtotal = row.price * row.amount
            var obj = {
                goodsId: row.goodsId,
                gid: row.gid,
                // userId: Cookies.get("UserID"),
                userId: this.serchUserId,
                amount: row.amount,
                isAddCart: 0 // 0代表从计数器点的  1代表从商品点的
            };
            actionsave(obj).then(response => {
                //   console.log(response)
                this.getAllAmount();
            });
            // 数量变化的时候，顶部导航头的数量跟着变化
            var dataNumLength = 0;
            for (var i = 0; i < this.tableData.length; i++) {
                dataNumLength = dataNumLength + this.tableData[i].amount;
            }
            this.$store.state.DataStorage.GoodLengthData = dataNumLength;
        },
        // 删除
        deleteRowHandler(row, index) {
            let vm = this;
            vm.$confirm("确定要删除吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                var obj = {
                    cartId: row.cartId
                };
                actiondelete(obj).then(response => {
                    //同时过滤 selectTableData
                    let index = vm.getGids(vm.selectTableData).indexOf(row.gid);
                    if(index > -1) vm.selectTableData.splice(index, 1);
                    vm.getShopCarData();
                });
            }).catch(() => {});
        },
        // 生成订单
        submitOrderHandler() {
            if (this.quantity) {                
                this.$confirm("确定要提交采购单吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "info"
                }).then(() => {
                    var result = [];
                    for (var i = 0; i < this.selectTableData.length; i++) {
                        result.push({
                            cartId: this.selectTableData[i].cartId,
                            amount: this.selectTableData[i].amount
                        });
                    }
                    var obj = {
                        userId: Cookies.get("UserID"),
                        userName: Cookies.get("name"),
                        orgId: Cookies.get("orgGid"),
                        orgName: Cookies.get("orgName"),
                        cartVoList: result
                    };
                    ordersave(obj).then(res => {
                        //添加“提交采购单”埋点
                        let doId = +localStorage.getItem('doId') + 1;
                        localStorage.setItem('doId', doId);
                        insertPoint(obj, 'click', 'order', doId); 
                        this.$router.push({
                            name: "OrderList",
                            query: { item: JSON.stringify(res.data) }
                        });
                    });
                });
            } else {
                //   console.log('您没有选择商品')
                this.$message({
                    message: "您还没有选择书本！",
                    type: "warning"
                });
            }
        },
        //把购物车全部数据生成清单
        submitAllOrderHandler() {
            let vm = this,
                ckindex = "-1",
                obj = {};        
            vm.$confirm("确定要全部提交采购单吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
            }).then(() => {
                if (vm.tabIndex == "1") {
                    ckindex = "1";
                } else if (vm.tabIndex == "2") {
                    ckindex = "0";
                }
                obj = {
                    userType:vm.IDGoodsType,  //身份筛选
                    userId: vm.serchUserId,   // 用户
                    cknums: ckindex,    // 
                    source:vm.serchSource,   // 来源
                    goodsType:vm.serchGoodsType    // 商品类型
                };
                allOrdersave(obj).then(res => {
                    if (res && res.status) {
                        //添加“提交采购单”埋点
                        let doId = +localStorage.getItem('doId') + 1;
                        localStorage.setItem('doId', doId);
                        insertPoint(obj, 'click', 'order', doId);
                        vm.$router.push({
                            name: "OrderList",
                            query: { item: JSON.stringify(res.data) }
                        });                    
                    }
                });
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getShopCarData();
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getShopCarData();
        }
    },
    components: { TopComponent, BottomComponent, Tabs, TabPane, Loading, Select, Option}
};
</script>

<style lang="scss">
.MyPurchaseStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
    .loading-wrap{
        position: relative;
    }
    .MouseCursor {
        cursor: pointer;
    }

    /* 1、导航 */
    .PurchaseTwoTop {
        width: 100%;
        height: 54px;
        background: #ffffff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
    }

    .PurchaseTwoTop-container {
        width: 1200px;
        height: 100%;
        display: flex;
        align-items: center;
        margin: 0px auto;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #000000;
    }

    /* 2、流程 */
    .PurchaseLiucheng {
        height: 60px;
        width: 1200px;
        margin: 30px auto 20px auto;
    }

    .el-steps--horizontal {
        width: 70%;
    }

    .PurchaseSearch{
        width: 1200px;
        margin: 10px auto 0px auto;
        label{
            font-size: 14px;
            color: #606266;
            &:not(:first-child){
                margin-left:20px;
            }
        }
    }

    /* 3、列表内容区 */
    .PurchaseContainer {
        width: 1200px;
        margin: 10px auto 0px auto;
    }

    .el-table img {
        width: 40px;
    }

    .PurchaseContainer >>> .el-table .cell {
        display: flex !important;
        align-items: center !important;
        justify-content: center;
    }

    .PurchaseContainer >>> .el-table .el-table__header-wrapper th {
        font-size: 14px !important;
        color: rgba(0, 0, 0, 0.85);
    }

    .PurchaseContainer >>> .el-table .el-table__body-wrapper td {
        font-size: 14px !important;
        color: #666666;
    }

    .PurchaseContainer
        >>> .el-table
        .el-table__body-wrapper
        .el-table_1_column_5
        div {
        color: #ff1212;
    }

    .priceBeforeStyle {
        text-decoration: line-through;
        font-size: 12px;
        color: #999999;
    }

    .totalTo {
        height: 32px;
        padding: 10px 15px;
        background: #fff;
        .el-pagination__sizes {
            margin-right: 0;
        }
        .el-pagination {
            padding: 2px 0px;
            .el-select .el-input {
                margin: 0;
            }
        }
    }
    .totalToRight {
        font-size:15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .guancangBook {
        color: brown;
        width: 120px;
    }
    .set_wrap{
        border:1px solid #fafafa;
        background-color: #fff;
        margin: 20px 0;
        padding: 20px 30px;
    }
    .setRule{
        font-size: 12px;
        padding: 10px 0;
        color: #666;
        .el-input{
            width: 45px;
            margin:0px 6px;
            input{
                text-align: center;
                padding: 0px 8px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/My-Purchase.vue